import { TModelFilters } from "./deprecated.types";

const taskFilters: TModelFilters = [
  {
    value: "all",
    name: "Todas",
    filter: {},
  },
];

export default taskFilters;
